import { initCookieBar } from './components/cookie-bar';
require('fslightbox');
jQuery(document).ready(function($) {
	initCookieBar();
	$('#btn-mobile-nav').click(function() {
		$('.nav-mobile .menu').stop().slideToggle(200);
	});

	const fixedElement = document.querySelector('#order_review');
	let fromTop;
	if (fixedElement) {
		fromTop = fixedElement.getBoundingClientRect().top + window.scrollY;
	}

	$('form.checkout.woocommerce-checkout').bind('DOMSubtreeModified',function(){
		if ($('ul.woocommerce-error').length) {
			$('ul.woocommerce-error').insertBefore('form.checkout');
			if (fixedElement) {
				fromTop = fixedElement.getBoundingClientRect().top + window.scrollY;
			}
		}
	});

	if (fixedElement) {
		window.addEventListener('scroll', () => {
			if (window.scrollY > (fromTop - 20)) {
				fixedElement.style.top = `${window.scrollY - fromTop + 20}px`;
			} else {
				fixedElement.style.top = 0;
			}
		});
  }

	$(document.body).on('adding_to_cart', '', () => {
		$('.page-content .woocommerce-notices-wrapper').html('');
	});

	$(document.body).on('added_to_cart', '', (event, fragments) => {
		if (fragments.notice) {
			$('.page-content .woocommerce-notices-wrapper').html(fragments.notice);
		}
	});

	$('input[data-trigger]').change(function () {
		$(document.body).trigger($(this).data('trigger'));
	});

	if ($('#countdown').length) {
		showRemaining($('#countdown').attr('data-timeleft'));
	}

	if (typeof refreshFsLightbox === 'function')
	{
		let gallery = document.querySelectorAll('.wp-block-gallery img');
		gallery.forEach(function(galleryItem)
		{
			let parent = galleryItem.parentNode;

			if (parent.tagName == 'A') {
				parent.setAttribute('data-fslightbox', 'galerija');
			} else {
				let src = galleryItem.getAttribute('data-full-url') || galleryItem.getAttribute('src');
				let href = document.createElement('a');
				href.setAttribute('href', src);
				href.setAttribute('data-fslightbox', 'galerija');

				galleryItem.parentNode.insertBefore(href, galleryItem);
				href.appendChild(galleryItem);
			}
		});

		refreshFsLightbox();
	}

	initListOrder();

	function initListOrder() {
		'use strict';
		$('.table-list').each(function () {
			let mylist = $(this);
			let headingRow = $(mylist).find('.heading');
			let btn = $(headingRow).find('.order-btn');
			let dataRows = $(mylist).find('.data');
			let data = [];
			let indexes = btn.length;
			let number;

			dataRows.each(function () {
				let el = $(this);
				let divs = el.find('div');

				let item = {
					el: el,
					/*  name: divs[0].innerText,
						lastName: divs[1].innerText,
						participantNumber: divs[2].innerText,
						team: divs[3].innerText,
						distance: divs[4].innerText*/
				};

				for (let i = 0; i<indexes; i++)
					item[i] = divs[i].innerText;

				data.push(item);
			});


			btn.click(function(){
				number = btn.index($(this));
				if ($(this).attr('order') == 'number'){
					orderByNumber($(this));
				}else if ($(this).attr('order') == 'text'){
					orderByText($(this));
				}
			});

			function orderByNumber(button){
				data.sort(function (a,b){
					let first = a[number];
					let second = b[number];
					first = parseFloat(first);
					second = parseFloat(second);
					if (button.hasClass('ordered')) {
						return first - second;
					}
					return second - first;
				});
				let els = [];
				$.each(data, function (idx, itm) {
					els.push(itm.el);
					// mylist.append(itm);
				});
				mylist.append(els);

				markAsOrdered(button);
			}

			function orderByText(button){
				data.sort(function (a,b){
					let first = a[number];
					let second = b[number];
					if (button.hasClass('ordered')) {
						return first.localeCompare(second);
					}
					return second.localeCompare(first);
				});
				let els = [];
				$.each(data, function (idx, itm) {
					els.push(itm.el);
					//mylist.append(itm);
				});
				mylist.append(els);

				markAsOrdered(button);
			}

			function markAsOrdered(button){
				if (button.hasClass('ordered')) {
					button.removeClass('ordered');
				}else{
					$(btn).removeClass('ordered');
					button.addClass('ordered');
				}
			}
		});
	}
});


function showRemaining(dt) {
	const timer = document.querySelector('.time-right.clock');
	const newDate = new Date(dt.replace(/\s/, 'T')+'Z').getTime(); // fix safari NaN - add T and Z

	const countdown = setInterval(() => {
		const date = new Date().getTime();
		const diff = newDate - date;

		const second = 1000;
		const minute = second * 60;
		const hour = minute * 60;
		const day = hour * 24;


		const days = Math.floor(diff / (day));
		const hours =  Math.floor((diff % (day)) / (hour));
		const minutes = Math.floor((diff % (hour)) / (minute));
		const seconds = Math.floor((diff % (minute)) / second);

		if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
			clearInterval(countdown);
			return;
		}

		timer.querySelector('.seconds').innerHTML = seconds < 10 ? '0' + seconds : seconds;
		timer.querySelector('.minutes').innerHTML = minutes < 10 ? '0' + minutes :minutes;
		timer.querySelector('.hours').innerHTML = hours < 10 ? '0' + hours : hours;
		timer.querySelector('.days').innerHTML = days < 10 ? '0' + days : days;
	}, 1000);
}
